import type React from 'react';

import { Link, ListItem, Separator, Text } from '@change/ds-core-ui';
import { ArrowRightIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useGuidesSection } from './hooks/useGuidesSection';

const GuideArticle: React.FC<{ title: string; guideLink: string; trackGuideLinkClick: (url: string) => void }> = ({
	title,
	guideLink,
	trackGuideLinkClick,
}) => (
	<div className="col-span-2 lg:col-span-1">
		<Link
			href={guideLink}
			underline={false}
			data-qa="impact-story-page-guide-link"
			onClick={() => trackGuideLinkClick(guideLink)}
			className="w-full [&>span]:w-full"
		>
			<ListItem
				forceInteractive
				className="rounded-none py-4"
				label={
					<Text size="medium" className="text-typography-interactive truncate text-left">
						{title}
					</Text>
				}
				trailingIcon={<ArrowRightIcon className="text-icon-accent-primary" />}
			/>
		</Link>
		<Separator className="m-0" />
	</div>
);

export const GuidesSection: React.FC = () => {
	const {
		data: { guideArticlesAndLinks },
		actions: { trackGuideLinkClick },
	} = useGuidesSection();

	return (
		<div>
			<div className="mb-6">
				<Text variant="heading" as="h2" className="text-typography-strong">
					<Translate value="corgi.impact_story.links_section_title" />
				</Text>
			</div>
			<Separator className="m-0" />
			{guideArticlesAndLinks.map((guide) => (
				<GuideArticle key={guide.title} {...guide} trackGuideLinkClick={trackGuideLinkClick} />
			))}
		</div>
	);
};
